import {render} from '@testing-library/react';

import {ReactElement} from 'react';

import {ComponentMockProvider} from '../components/ComponentMockProvider/ComponentMockProvider';

export const renderComponentWithProviders = (component: ReactElement) =>
  render(component, {
    wrapper: ({children}) => <ComponentMockProvider>{children}</ComponentMockProvider>,
  });
